import { object, string } from 'yup'
export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  query: string().required(),
})

export const url = ({ query }) => `/v1/icd_codes/search?query=${query}`
